// Module
var code = "<script>let $ctrl</script> <div class=\"flexWrapper__headerPanel\"> <organism-page-header-panel page-header-data=\"$ctrl.pageHeaderData\"></organism-page-header-panel> </div> <organism-redirection-wizard-wrapper></organism-redirection-wizard-wrapper> ";
// Exports
module.exports = code;